module.exports = __webpack_public_path__ + "static/media/pause.303e0c5a.svg";